
/**
 * Classe responsável mapear os tipos de atributos da camada
*/

export default class TipoGeometria {
	
	static get POLIGONO () {
		return {
			nome: 'Polígono',
			codigo: 'POLYGON'
		};
	}

	static get LINHA () {
		return {
			nome: 'Linha',
			codigo: 'LINESTRING'
		};
	}

	static get PONTO () {
		return {
			nome: 'Ponto',
			codigo: 'POINT'
		};
	}

	static getFromGeoJsonType (type) {

		if (!type) return null;
		type = type.toLowerCase();

		switch (type) {
		case 'point':
		case 'multipoint':
			return this.PONTO;

		case 'linestring':
		case 'multilinestring':
			return this.LINHA;

		case 'polygon':
		case 'multipolygon':
			return this.POLIGONO;

		default:
			return null;
		}
	}

	static getFromGeoJson (geoJson) {

		if (geoJson.type) {

			let tipo = this.getFromGeoJsonType(geoJson.type);
			if (tipo) return tipo;
		}

		var features = geoJson instanceof Array ? geoJson : geoJson.features;

		if (!features || features.length === 0) return null;

		var geometry = features[0].type === 'Feature' ? features[0].geometry : features[0];
		
		return this.getFromGeoJsonType(geometry.type);
	}
}



// WEBPACK FOOTER //
// ./src/models/tipoGeometria.js